import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SUPPLIER_SETTINGS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SUPPLIER_SETTINGS');
export const SUPPLIER_SETTINGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SUPPLIER_SETTINGS_CRUD_ACTION_CONSTANTS
);
